import moment from "moment";

// console.log("IST Time:", istTime.format("YYYY-MM-DD HH:mm:ss"));

export const convertUtcToIST = (utcDateString) => {
  if (!utcDateString || utcDateString === "null") {
    return null;
  }
  const utcTime = moment.utc(utcDateString);

  if (!utcTime.isValid()) {
    return null;
  }

  // Add 5 hours 30 minutes for IST
  const istTime = utcTime.add(5, "hours").add(30, "minutes");

  return istTime.format("DD-MM-YYYY"); // Local time
};

// export convertUtcToIST;
